"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBankCardRequest = void 0;
var CheckBankCardRequest = /** @class */ (function () {
    function CheckBankCardRequest() {
    }
    return CheckBankCardRequest;
}());
exports.CheckBankCardRequest = CheckBankCardRequest;
;
//# sourceMappingURL=checkBankCard.request.js.map